import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn 惯例:合并 className(条件类 + Tailwind 冲突去重)。 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
